// Timezone preference context. Defaults to IST (Asia/Kolkata).
// Persists selection in localStorage.

import { createContext, useContext, useState } from 'react';

export type TzId = 'Asia/Kolkata' | 'Europe/London';

interface TimezoneCtx {
  tz: TzId;
  label: string;
  otherTz: TzId;
  otherLabel: string;
  toggle: () => void;
}

const TimezoneContext = createContext<TimezoneCtx>({
  tz: 'Asia/Kolkata',
  label: 'IST',
  otherTz: 'Europe/London',
  otherLabel: 'UK',
  toggle: () => {},
});

export function TimezoneProvider({ children }: { children: React.ReactNode }) {
  const [tz, setTz] = useState<TzId>(
    () => (localStorage.getItem('hikari_tz') as TzId) || 'Asia/Kolkata',
  );

  const toggle = () => {
    setTz(prev => {
      const next: TzId = prev === 'Asia/Kolkata' ? 'Europe/London' : 'Asia/Kolkata';
      localStorage.setItem('hikari_tz', next);
      return next;
    });
  };

  const label = tz === 'Asia/Kolkata' ? 'IST' : 'UK';
  const otherTz: TzId = tz === 'Asia/Kolkata' ? 'Europe/London' : 'Asia/Kolkata';
  const otherLabel = tz === 'Asia/Kolkata' ? 'UK' : 'IST';

  return (
    <TimezoneContext.Provider value={{ tz, label, otherTz, otherLabel, toggle }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export const useTimezone = () => useContext(TimezoneContext);
